export default "__VITE_ASSET__Cp9qMJIh__"